import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/urbanareas`;

export default {
  filterUrbanAreasByCity(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${resource}/search-by-city-id`, {
      baseURL,
      headers,
      params,
    });
  },
  getUrbanareaById(id, baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${resource}/${id}`, {
      baseURL,
      headers,
      params,
    });
  },
};
